/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode: * `cloud` - Cloud authorization * `token` - HW token authorization * `offline` - The Offline mode is a special mode of FCC that allow a token based FCC to run without regular online connection. * `swissbit_token` - SWISSBIT hardware token connected directly to machine FCC is running on 
 */
export enum VirtualTssModeEnumDTO {
    CLOUD = 'cloud',
    TOKEN = 'token',
    OFFLINE = 'offline',
    SWISSBIT_TOKEN = 'swissbit_token'
}

export class ClsVirtualTssModeEnumDTO {
    CLOUD = 'cloud';
    TOKEN = 'token';
    OFFLINE = 'offline';
    SWISSBIT_TOKEN = 'swissbit_token';
}

